<template>
  <gg-card height="100%" class="d-flex flex-column">
    <gg-card-header>
      I Need Help
    </gg-card-header>
    <gg-card-text>
      If you need assistance, click the button below to get in touch with our Support Team.
      Our team will assist with resolving this alert and explaining your options.
    </gg-card-text>
    <v-card-actions class="justify-end mt-auto pa-4">
      <gg-btn :to="{ name: 'support_ticketnew', query: { d: 'Support', s: alert.serviceID, sbj: subject } }">
        Open Ticket
      </gg-btn>
    </v-card-actions>
  </gg-card>
</template>

<script>
export default {
  name: 'Help',
  props: {
    alert: {
      required: true,
      type: Object
    }
  },
  computed: {
    subject () {
      return `Alert Assistance: ${this.alert.title}`
    }
  }
}
</script>
